import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface BoardMemberProps {
  name: string;
  role: string;
  description: string;
  avatarSize?: "large" | "default";
  delay?: number;
  imageUrl?: string;
}

export const BoardMemberCard = ({ 
  name, 
  role, 
  description, 
  avatarSize = "default",
  delay = 0,
  imageUrl 
}: BoardMemberProps) => {
  console.log("BoardMemberCard rendering:", { name, role, avatarSize, imageUrl });
  
  const avatarDimensions = avatarSize === "large" ? "h-24 w-24" : "h-20 w-20";
  const titleSize = avatarSize === "large" ? "text-2xl" : "text-xl";
  const descriptionSize = avatarSize === "large" ? "text-lg" : "text-base";

  return (
    <Card 
      className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:border-primary/50 animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
    >
      <CardHeader className="flex flex-row items-center gap-4">
        <Avatar className={`${avatarDimensions} border-2 border-primary transition-transform duration-300 group-hover:scale-105`}>
          {imageUrl && <AvatarImage src={imageUrl} alt={name} />}
          <AvatarFallback className="bg-primary text-primary-foreground text-2xl">
            {name.split(' ').map(n => n[0]).join('')}
          </AvatarFallback>
        </Avatar>
        <div>
          <CardTitle className={`${titleSize} mb-1 group-hover:text-primary transition-colors duration-300`}>
            {name}
          </CardTitle>
          <CardDescription className={`${descriptionSize} text-muted-foreground group-hover:text-primary/70 transition-colors duration-300`}>
            {role}
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground leading-relaxed group-hover:text-foreground transition-colors duration-300">
          {description}
        </p>
      </CardContent>
    </Card>
  );
};